module.exports = __webpack_public_path__ + "static/media/brush.3273fc82.svg";